import { transformApplicantToApi, transformMerchantId } from '@applyonline/shared'
import { CreditApplication } from '../types/Schemas/CreditApplicationSchema'

export function transformCreditToApi(credit: CreditApplication): CreditApplication {
  return {
    ...credit,
    merchantId: transformMerchantId(credit.merchantId, 'monolith'),
    applicant: transformApplicantToApi(credit.applicant),
  } as CreditApplication 
}